{
  const initPdpStickyBottom = () => {
    const form = document.querySelector('.product-info .product-form.sticky-content-container');
    if (!form) return;

    const container = form.closest('.detail') || form.parentElement;
    form.style.position = '';
    form.style.left     = '';
    form.style.width    = '';
    if (container) container.style.position = '';

    const update = () => {
      requestAnimationFrame(() => {
        const viewportH = window.innerHeight;
        const formH = form.offsetHeight;
        const gap = 180;
        const topValue = Math.min(gap, viewportH - formH - gap);

        document.documentElement.style.setProperty('--pdp-sticky-form-top', `${topValue}px`);
      });
    };

    update();
    window.addEventListener('on:debounced-resize', update);
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(form);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpStickyBottom);
  } else {
    initPdpStickyBottom();
  }
}